import { AnyAction } from 'redux'
import requestStatuses, { RequestStatus } from '@cinch/oxd-utils/request-status/src'
import {
  PARTEX_CLEAR_VALUATION,
  PARTEX_CREATE_VALUATION_REQUEST,
  PARTEX_CREATE_VALUATION_COMPLETE,
  PARTEX_CREATE_VALUATION_ERROR,
  PARTEX_VARIANTS_REQUEST,
  PARTEX_VARIANTS_COMPLETE,
  PARTEX_VARIANTS_ERROR,
  PARTEX_UPDATE_APPRAISAL,
  PARTEX_UPDATE_VRM,
  PARTEX_VARIANT_SELECT,
} from '../types'

export interface PartexValuation {
  colour: string
  derivative: string
  grade: number
  id: string
  model: string
  make: string
  mileage: number
  valueInPence: number
  vrm: string
}
export interface PartexVehicleVariant {
  bodyType: string
  capId: string
  capDescription: string
  capIntroducedDate: string
  capDiscontinuedDate: string
  colour: string
  derivative: string
  engineSize: string
  fuelType: string
  make: string
  model: string
  numberOfDoors: string
  registrationDate: string
  registrationNumber: string
  transmissionType: string
  vehicleType: string
  vin: string
}

export enum PartexAppraisalRegisteredKeeperValue {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  FivePlus = '5+',
}

export enum PartexAppraisalVehicleConditionValue {
  Excellent = 'Excellent',
  Good = 'Good',
  Average = 'Average',
  BelowAverage = 'Below average',
  Poor = 'Poor',
}

export interface PartexAppraisalQuestions {
  mileage?: number
  registeredKeepers?: PartexAppraisalRegisteredKeeperValue
  vehicleCondition?: PartexAppraisalVehicleConditionValue
}

export interface PartexState extends PartexAppraisalQuestions {
  condition?: string
  createValuationRequestError?: string
  createValuationRequestStatus: RequestStatus
  getVariantsRequestError?: string
  getVariantsRequestStatus: RequestStatus
  valuation?: PartexValuation
  variant?: PartexVehicleVariant
  variants: PartexVehicleVariant[]
  vrm?: string
}

export const initialState: PartexState = {
  createValuationRequestStatus: requestStatuses.INITIAL,
  getVariantsRequestStatus: requestStatuses.INITIAL,
  variants: [],
}

export default function deliveryReducer(state = initialState, action: AnyAction): PartexState {
  switch (action.type) {
    case PARTEX_CLEAR_VALUATION:
      return {
        ...state,
        valuation: undefined,
      }
    case PARTEX_CREATE_VALUATION_REQUEST:
      return {
        ...state,
        createValuationRequestStatus: requestStatuses.PENDING,
      }
    case PARTEX_CREATE_VALUATION_COMPLETE:
      return {
        ...state,
        createValuationRequestStatus: requestStatuses.SUCCESS,
        valuation: action.payload,
      }
    case PARTEX_CREATE_VALUATION_ERROR:
      return {
        ...state,
        createValuationRequestStatus: requestStatuses.ERROR,
        createValuationRequestError: action.payload,
      }
    case PARTEX_VARIANTS_REQUEST:
      return {
        ...state,
        getVariantsRequestStatus: requestStatuses.PENDING,
      }
    case PARTEX_VARIANTS_COMPLETE:
      return {
        ...state,
        ...(action.payload.length === 1 && { variant: action.payload[0] }),
        variants: action.payload,
        getVariantsRequestStatus: requestStatuses.SUCCESS,
      }
    case PARTEX_VARIANTS_ERROR:
      return {
        ...state,
        getVariantsRequestError: action.payload,
        getVariantsRequestStatus: requestStatuses.ERROR,
      }
    case PARTEX_UPDATE_APPRAISAL:
      return {
        ...state,
        ...action.payload,
      }
    case PARTEX_UPDATE_VRM:
      return {
        ...state,
        vrm: action.payload,
      }
    case PARTEX_VARIANT_SELECT:
      return {
        ...state,
        variant: action.payload,
      }
    default:
      return state
  }
}
